export const backendHost = import.meta.env.VITE_BACKEND_HOST;
export const ENV = import.meta.env.VITE_ENV;